import { useState, useCallback } from "react";
import { CostAnalysisService } from "../../../application/services/aiServices/costAnalysisService";

const costAnalysisService = new CostAnalysisService();

export const useCostAnalysis = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [costAnalysis, setCostAnalysis] = useState(null);

  const getLatestCostAnalysis = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await costAnalysisService.getLatestCostAnalysis();
      if (result.success) {
        setCostAnalysis(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  const analyzeCosts = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await costAnalysisService.analyzeCosts();
      if (result.success) {
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    getLatestCostAnalysis,
    analyzeCosts,
    costAnalysis,
    loading,
    error,
  };
};